export const FILE_TYPE_ERROR_MSG = "请上传jpg/png/mp4格式的图片或视频"
export const FILE_SIZE_ERROR_MSG = "请上传小于[size]的[fileType]"
export const FILE_LENGTH_ERROR_MSG = "最多上传[limitLength]张图片或视频!"
export const FILE_SIZE_VIDEO_ERR_MSG = "视频超出[size]，不能上传"
export const FILE_TYPE_MAP = {
  image: "图片",
  video: "视频"
}
